"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _bulkAddTimelineEvent = _interopRequireDefault(require("../../../../../constants/bulkAddTimelineEvent"));

var _utils = require("../../../../../../../common/utils");

var _AssetPreview = _interopRequireDefault(require("./AssetPreview"));

var _AssetTitle = _interopRequireDefault(require("../../../../../../../common/components/AssetTitle"));

require("../styles/_assets-tab.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getFilteredAssets = (0, _memoizeOne.default)(function (assets, filter) {
  return assets.filter(function (asset) {
    return asset && !(0, _utils.isAssetMissing)(asset) && asset.title && asset.title.toLowerCase().includes(filter.toLowerCase());
  });
});

var AssetsTab = /*#__PURE__*/function (_Component) {
  _inherits(AssetsTab, _Component);

  var _super = _createSuper(AssetsTab);

  function AssetsTab() {
    var _this;

    _classCallCheck(this, AssetsTab);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onChangeFilter", function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        filter: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectAsset", (0, _lodash.default)(function (assetId) {
      return function () {
        var selectedAssets = _this.state.selectedAssets;
        var selected = selectedAssets[assetId];

        if (!selected) {
          return void _this.setState({
            selectedAssets: _objectSpread({}, selectedAssets, _defineProperty({}, assetId, true))
          }, _this.updateSelectedAssets);
        }

        _this.setState({
          selectedAssets: _objectSpread({}, selectedAssets, _defineProperty({}, assetId, false))
        }, _this.updateSelectedAssets);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onSelectAll", function () {
      var selectedAssets = _this.state.selectedAssets;
      var assets = _this.props.assets;
      var noOfSelectedAssets = Object.values(selectedAssets).filter(Boolean).length; // Select All

      if (!noOfSelectedAssets || noOfSelectedAssets !== assets.length) {
        return void _this.setState({
          selectedAssets: assets.filter(Boolean).reduce(function (selected, asset) {
            return _objectSpread({}, selected, _defineProperty({}, asset.assetId, true));
          }, {})
        }, _this.updateSelectedAssets);
      } // Deselect all


      _this.setState({
        selectedAssets: {}
      }, _this.updateSelectedAssets);
    });

    _defineProperty(_assertThisInitialized(_this), "updateSelectedAssets", function () {
      var selectedAssets = _this.state.selectedAssets;
      var _this$props = _this.props,
          onUpdateSelectedDrawerAssets = _this$props.onUpdateSelectedDrawerAssets,
          assets = _this$props.assets;
      onUpdateSelectedDrawerAssets(Object.entries(selectedAssets).reduce(function (newAssets, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            assetId = _ref3[0],
            selected = _ref3[1];

        if (!selected) {
          return newAssets;
        }

        var selectedAsset = assets.find(function (asset) {
          return asset.assetId === assetId;
        });
        return [].concat(_toConsumableArray(newAssets), [selectedAsset]);
      }, []));
    });

    _defineProperty(_assertThisInitialized(_this), "dispatchAddToTimelineEvent", function () {
      document.dispatchEvent(new Event(_bulkAddTimelineEvent.default));
    });

    _this.state = {
      filter: '',
      selectedAssets: {}
    };
    return _this;
  }

  _createClass(AssetsTab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          assets = _this$props2.assets,
          canUpdateVideo = _this$props2.canUpdateVideo;
      var _this$state = this.state,
          filter = _this$state.filter,
          selectedAssets = _this$state.selectedAssets;
      var filteredAssets = getFilteredAssets(assets, filter);
      var noOfSelectedAssets = Object.values(selectedAssets).filter(Boolean).length;
      var hiddenSelected = Object.entries(selectedAssets).filter(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            assetId = _ref5[0],
            selected = _ref5[1];

        return selected && !filteredAssets.some(function (_ref6) {
          var filteredId = _ref6.assetId;
          return assetId === filteredId;
        });
      });
      var hiddenSelectedDisplayString = hiddenSelected.length ? "( ".concat(hiddenSelected.length, " HIDDEN )") : '';
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "assets-tab"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          className: "assets-tab__search",
          placeholder: "Search",
          prefix: "search",
          onChange: this.onChangeFilter
        }), /*#__PURE__*/_react.default.createElement("h6", null, "Video Assets (".concat(assets.length, ")")), /*#__PURE__*/_react.default.createElement("p", null, "Assets located here will be packaged for editing"), /*#__PURE__*/_react.default.createElement(_uiKit.BulkActions, {
          darkMode: true,
          totalItems: assets.length,
          selectedItems: noOfSelectedAssets,
          suffix: hiddenSelectedDisplayString,
          onSelectAll: this.onSelectAll
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "assets-tab__list"
        }, filteredAssets.map(function (asset) {
          return (/*#__PURE__*/_react.default.createElement("div", {
              className: (0, _classnames.default)('assets-tab__list__asset', {
                'assets-tab__list__asset--disabled': !canUpdateVideo
              }),
              key: asset.assetId
            }, /*#__PURE__*/_react.default.createElement(_uiKit.Checkbox, {
              checked: selectedAssets[asset.assetId],
              onChange: _this2.onSelectAsset(asset.assetId)
            }), /*#__PURE__*/_react.default.createElement(_AssetPreview.default, {
              borderRadius: 6,
              canPlayVideo: true,
              asset: asset,
              width: 270,
              height: 130,
              canUpdateVideo: canUpdateVideo,
              isSelected: selectedAssets[asset.assetId],
              darkMode: true
            }), /*#__PURE__*/_react.default.createElement(_AssetTitle.default, {
              assetId: asset.assetId,
              className: "assets-tab__list__asset__name"
            }))
          );
        }), !filteredAssets.length && /*#__PURE__*/_react.default.createElement("p", {
          className: "assets-tab__list__empty"
        }, "There are no video assets that match your filters. Try clearing the filters.")), noOfSelectedAssets ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          className: "assets-tab__add-timeline-btn",
          onClick: this.dispatchAddToTimelineEvent
        }, "ADD TO TIMELINE (".concat(noOfSelectedAssets, ")")) : null)
      );
    }
  }]);

  return AssetsTab;
}(_react.Component);

exports.default = AssetsTab;